import React from 'react'
import ErrorMessage from './ErrorMessage'

type Props = { error?: Error, message?: string }
const FullScreenError: React.FC<Props> = ({ error, message }) => {
  return (
    <div className='h-screen'>
      <ErrorMessage error={error} message={message} />
    </div>
  )
}

export default FullScreenError
